import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Requer qualquer assinatura ativa (inclusive trial)
export function RotaProtegida({ children }) {
  const { usuario, temAssinatura, carregando } = useAuth();
  if (carregando) return <div className="carregando">Carregando…</div>;
  if (!usuario) return <Navigate to="/login" replace />;
  if (!temAssinatura()) return <Navigate to="/planos?msg=assinatura" replace />;
  return children;
}

// Apenas requer estar logado (sem exigir assinatura)
export function RotaLogada({ children }) {
  const { usuario, carregando } = useAuth();
  if (carregando) return <div className="carregando">Carregando…</div>;
  if (!usuario) return <Navigate to="/login" replace />;
  return children;
}

// Requer plano premium ativo
export function RotaPremium({ children }) {
  const { usuario, temAssinatura, ehPremium, carregando } = useAuth();
  if (carregando) return <div className="carregando">Carregando…</div>;
  if (!usuario) return <Navigate to="/login" replace />;
  if (!temAssinatura()) return <Navigate to="/planos?msg=assinatura" replace />;
  if (!ehPremium()) return <Navigate to="/planos?msg=premium" replace />;
  return children;
}

// Requer ser admin
export function RotaAdmin({ children }) {
  const { usuario, ehAdmin, carregando } = useAuth();
  if (carregando) return <div className="carregando">Carregando…</div>;
  if (!usuario || !ehAdmin()) return <Navigate to="/" replace />;
  return children;
}
